export default "__VITE_ASSET__96b56953__"